import { Action, Reducer } from 'redux';
import { SettingsState } from 'models/state/settings';
// eslint-disable-next-line import/no-cycle
import {
  SettingsActions,
  SETTINGS_FETCH_REQUEST,
  SETTINGS_FETCH_SUCCESS,
  SETTINGS_FETCH_FAILURE,
} from './actions';

// ----------------
// REDUCER - For a given state and action, returns the new state. To support time travel, this must not mutate the old state.
const defaultSettingsState: SettingsState = {
  settings: undefined,
  loading: false,
  error: undefined,
};

export const reducer: Reducer<SettingsState> = (
  state: SettingsState = defaultSettingsState,
  incomingAction: Action | undefined = undefined
): SettingsState => {
  const action = incomingAction as SettingsActions;

  switch (action.type) {
    case SETTINGS_FETCH_REQUEST:
      return { ...state, loading: true };

    case SETTINGS_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        settings: action.payload,
        error: undefined,
      };

    case SETTINGS_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        settings: undefined,
        error: action.payload,
      };

    default:
      return state;
  }
};
